/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Conf_HighInputs */

const cs_addr_conf_high = /** @type {(inputs: Addr_Conf_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vysoká jistota`)
};

const en_addr_conf_high = /** @type {(inputs: Addr_Conf_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High confidence`)
};

/**
* | output |
* | --- |
* | "High confidence" |
*
* @param {Addr_Conf_HighInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_conf_high = /** @type {((inputs?: Addr_Conf_HighInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Conf_HighInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_conf_high(inputs)
	return cs_addr_conf_high(inputs)
});